export default "__VITE_ASSET__NwrLmCfg__"